import * as UIToolkit from '../../UIToolkit/index';
import * as Toolkit from '../../toolkit/index';
import * as CubeTree from '../../cubeTree/index';
import LinkedList from '../../utils/linkedList';
import Utils from '../../utils/util';
import CodiSystem from '../../codiSystem/index';
import { __walk__, __length__, __replaceAll__, __clearShortLink__, __getLinks__ } from './db';
import { renderLinkStyle } from './style';
import { updateLayoutKey, updateGroupedKey, getGroupList, createLink } from './link';
import { groupLayout } from './groupLayout';
import { cubeModify } from '../../update/cubeModify';

let updateLayerGroupInfoTimer: number;

function updateLayerGroupStausAsync(): void {
    if (updateLayerGroupInfoTimer) {
        clearTimeout(updateLayerGroupInfoTimer);
        updateLayerGroupInfoTimer = null;
    }

    updateLayerGroupInfoTimer = setTimeout(() => {
        updateLayerGroupStatus();
    }, 10);
}

function updateLayerGroupStatus(): void {
    let temp: LinkedListInstance[][] = [];
    let linkCount: number = __length__();

    // 如果没有编组，直接退出
    if (linkCount === 0) {
        __replaceAll__([]);
        updateModuleGroups();
        return;
    }

    // 防止坐标系统更新延迟，所以这里主动同步触发一次坐标更新
    CodiSystem.updateAllSync();
    __replaceAll__(cleanLinks());
    __walk__((link: LinkedListInstance, index: number): void => {
        temp.push(updateLink(link));
    });
    __replaceAll__(Utils.expandArray(temp));
    Toolkit.log({
        action: '层板连接',
        msgList: [
            {
                name: '层板编组列表:',
                value: getGroupList()
            }
        ]
    });

    let links: LinkedListInstance[] = __getLinks__();
    
    updateLayoutKey(links);
    renderLinkStyle(links);
    updateGroupedKey(links);
    groupLayout(links);
    __clearShortLink__();
    updateModuleGroups();
    Toolkit.log({
        action: '层板连接',
        msgList: [
            {
                name: '删除长度为1的编组:',
                value: getGroupList()
            }
        ]
    });
}

function updateModuleGroups(): void {
    let stage: CubeId = CubeTree.findSketchpad();
    let groupList: CubeId[][] = getGroupList();

    cubeModify(stage, {
        moduleGroups: JSON.stringify(groupList)
    });
}

function updateTargetLayerGroupStatus(link: LinkedListInstance): void {
    let list: LinkedListInstance[] = [link];

    updateLayoutKey(list);
    renderLinkStyle(list);
    updateGroupedKey(list);
    __clearShortLink__();
    groupLayout(list);
    updateModuleGroups();
    Toolkit.log({
        action: '层板连接',
        msgList: [
            {
                name: '层板编组列表:',
                value: getGroupList()
            }
        ]
    });
}

// 遍历每个编组中的层板，如果存在不符合编组条件的层板，则打散
function updateLink(link: LinkedListInstance): LinkedListInstance[] {
    let result: LinkedListInstance[] = [];
    let newList: LinkedListInstance = new LinkedList();
    let linkLayers: CubeId[] = link.valueList();
    let sortIds: CubeId[] = CodiSystem.sortByLeft(linkLayers);
    let newLink: LinkedListInstance = createLink(sortIds);

    for (let i = 0; i < newLink.length; i++) {
        let cur: LinkedNodeInstance = newLink.getElementAt(i);
        let next: LinkedNodeInstance|null = newLink.findNext(cur.val);
        let nextLayer: CubeId|null = next ? next.val : null;

        if (newList.length === 0) {
            result.push(newList);
        }
        newList.append(cur.val);

        if (!nextLayer) {
            break;
        }

        let checkResult: ValidateResult = validate([cur.val, nextLayer]);

        if (checkResult.code !== 0) {
            newList = new LinkedList();
        }
    };

    return result;
}

function validate(allSelected: CubeId[]): ValidateResult {
    if (CubeTree.hasBeam(allSelected)) {
        return {
            code: 1,
            msg: '横杆不能参与编组'
        };
    }

    if (!CubeTree.isCanDropPartitionList(allSelected)) {
        return {
            code: 1,
            msg: '该操作仅支持可放置层板'
        };
    }

    if (!UIToolkit.layerInAdjoiningShelf(allSelected)) {
        return {
            code: 1,
            msg: '层板必须在相邻货架内'
        };
    }

    if (!UIToolkit.layerIsTopAlign(allSelected)) {
        return {
            code: 1,
            msg: '层板必须顶端对齐'
        };
    }

    let sortIds: CubeId[] = CodiSystem.sortByLeft(allSelected);

    if (!UIToolkit.layersIsTouch(sortIds)) {
        return {
            code: 1,
            msg: '编组层板之间不能存在缝隙'
        };
    }

    return {
        code: 0,
        msg: ''
    };
}

// 删除编组不存在的 layerId，层板、货架删除时的场景
function cleanLinks(): LinkedListInstance[] {
    let result: LinkedListInstance[][] = [];

    __walk__((link: LinkedListInstance, index: number):  void => {
        let layers: CubeId[] = link.valueList();
        let remove: CubeId[] = layers.filter((layer: CubeId): boolean => {
            return !CubeTree.has(layer);
        });

        result.push(Toolkit.linkSplit(link, remove));
    });

    return Utils.expandArray(result);
}

export {
    updateLayerGroupStausAsync,
    validate,
    updateTargetLayerGroupStatus,
    updateLayerGroupStatus
};
